import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteUserPayload } from '@app-store/slices/users/delete'

interface TaskAction extends Action {
    payload: IDeleteUserPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.users.delete

function* deleteUserSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/users/${payload.data.id}`)
        if (response.success) {
            yield put(onSuccess(''))
            if (payload?.sagaCB) {
                yield put(payload?.sagaCB?.onSuccess(response.result))
            }
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteUserSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteUserSagaTask)
}

export default deleteUserSaga
